import {
  auditlog,
  auditLogFilterActions,
  auditLogFilterEmails,
  downloadAudit,
} from '../../utils/api';
import { FAILED, LOADING, SUCCESS, actionTypes } from './constants';

export function setFilterAction({ key, filter = {} }) {
  return { type: actionTypes.FILTER, key, filter };
}

export function fetchAuditLog(params) {
  return async (dispatch, getState) => {
    const state = getState();
    const KEY = 'Audit';
    let dataList  = [];
    const { totalPage } = state.auditLog.dataAudit?.meta || {
      totalPage: 0
    };
    if (params.page > 1 && params.page > totalPage) {
      return;
    }
    try {
      if (params?.page !== 1 && params?.page !== '1') {
        dataList = getState().auditLog.dataAudit.data;
      }
      dispatch(loadingAction(true, KEY));
      const { data, meta } = await auditlog(params);
      dispatch(successAction({ data: [ ...dataList, ...data] , meta }, KEY));
    } catch (error) {
      dispatch(failedAction(error.message, KEY));
    }
  };
}

export function fetchDownload(params) {
  return async (dispatch) => {
    const key = 'Download';

    try {
      dispatch(loadingAction(true, key));
      const { data } = await downloadAudit(params);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
}

export function fetchAuditLogActions(params) {
  return async (dispatch, getState) => {
    const key = 'AuditActions';
    const nextPage = Number(params?.page || 1);
    const currentState = getState().auditLog.dataAuditActions || {};
    const { totalPage = 0 } = currentState.meta || {};
    const currentData = currentState.data || [];

    if (nextPage > 1 && nextPage > totalPage) {
      return;
    }

    try {
      dispatch(loadingAction(true, key));
      const response = await auditLogFilterActions(params);
      const nextData = Array.isArray(response?.data)
        ? response.data
        : response?.data?.data || [];
      const nextMeta = response?.meta || response?.data?.meta || {
        page: nextPage,
        totalPage: nextPage,
        totalData: nextData.length,
      };

      dispatch(
        successAction(
          {
            data: nextPage > 1 ? [...currentData, ...nextData] : nextData,
            meta: nextMeta,
          },
          key
        )
      );
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
}

export function fetchAuditLogEmails(params) {
  return async (dispatch, getState) => {
    const key = 'AuditEmails';
    const nextPage = Number(params?.page || 1);
    const currentState = getState().auditLog.dataAuditEmails || {};
    const { totalPage = 0 } = currentState.meta || {};
    const currentData = currentState.data || [];

    if (nextPage > 1 && nextPage > totalPage) {
      return;
    }

    try {
      dispatch(loadingAction(true, key));
      const response = await auditLogFilterEmails(params);
      const nextData = Array.isArray(response?.data)
        ? response.data
        : response?.data?.data || [];
      const nextMeta = response?.meta || response?.data?.meta || {
        page: nextPage,
        totalPage: nextPage,
        totalData: nextData.length,
      };

      dispatch(
        successAction(
          {
            data: nextPage > 1 ? [...currentData, ...nextData] : nextData,
            meta: nextMeta,
          },
          key
        )
      );
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
}

export function resetAuditLogActionsOptions() {
  return async (dispatch) => {
    dispatch(successAction({
      data: [],
      meta: {
        page: 0,
        totalPage: 0,
        totalData: 0,
      },
    }, 'AuditActions'));
  };
}

export function resetAuditLogEmailsOptions() {
  return async (dispatch) => {
    dispatch(successAction({
      data: [],
      meta: {
        page: 0,
        totalPage: 0,
        totalData: 0,
      },
    }, 'AuditEmails'));
  };
}

export function setAuditLogFilter(filter) {
  return async (dispatch) => {
    dispatch(
      setFilterAction({
        key: 'filterAudit',
        filter,
      })
    );
  };
}

export function clearError(){
  return async (dispatch) => {
    const key = 'ErrorUnduhLog';
    dispatch(failedAction(false,key));
  };
}

export function seterrorUnduh() {
  return async (dispatch) => {
    const key = 'ErrorUnduhLog';
    dispatch(loadingAction(true, key));
    setTimeout(() => {
      dispatch(failedAction(true, key));
      dispatch(loadingAction(false, key));
    });
  };
}

export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key, message) {
  return { type: SUCCESS, data, key, message: message };
}
